import clsx from 'clsx'
import React from 'react'
import PropTypes from 'prop-types'

const colors = [
    {
        label: 'Gray - Lines',
        value: '#E3E7ED',
        color: 'grayLines',
    },
    {
        label: 'Gray - Background',
        value: '#F9FAFB',
        color: 'grayBackground',
    },
    {
        label: 'Text - Darker Gray',
        value: '#404E68',
        color: 'textDarkerGray',
    },
    {
        label: 'Text - Dark Gray',
        value: '#8594A8',
        color: 'textDarkGray',
    },
    {
        label: 'Links - Blue',
        value: '#1E50AE',
        color: 'linksBlue',
    },
    {
        label: 'Black',
        value: '#0C0D0E',
        color: 'black',
    },
    {
        label: 'Black - 90',
        value: '#212327',
        color: 'black90',
    },
    {
        label: 'Black - 80',
        value: '#282B2F',
        color: 'black80',
    },
    {
        label: 'Black - 70',
        value: '#2D3034',
        color: 'black70',
    },
    {
        label: 'Black - 60',
        value: '#363A3F',
        color: 'black60',
    },
    {
        label: 'Black - 50',
        value: '#474C52',
        color: 'black50',
    },
    {
        label: 'Black - 30',
        value: '#8C9297',
        color: 'black30',
    },
    {
        label: 'Error Red',
        value: '#F05252',
        color: 'error',
    },
]

const ColorLine = ({ label, value, color }) => {
    return (
        <div className="w-60 overflow-hidden h-40 rounded-2xl border border-grayLines flex flex-col items-center justify-between">
            <div className={clsx('h-1/2 w-full', `bg-${color}`)} />
            <div className="h-1/2 w-full p-4 bg-gray-700 flex flex-col items-start justify-start">
                <p className="text-white text-sm font-medium">{label}</p>
                <p className="text-xs text-black30 font-normal mt-2">
                    {value} {` (${color})`}
                </p>
            </div>
        </div>
    )
}

ColorLine.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
}

const Colors = () => {
    return (
        <div className="flex flex-row flex-wrap items-center justify-start gap-4 w-full h-auto m-auto">
            {colors.map(color => (
                <ColorLine key={color.value} {...color} />
            ))}
        </div>
    )
}

export default Colors
